import { Component, Input } from '@angular/core';
import { MenuItem } from '../types/menu-item.type';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { ROLES } from '../constants/roles.constants';

@Component({
    selector: 'app-menu-card',
    standalone: true,
    imports: [
        MatCardModule,
        MatIcon
    ],
    templateUrl: './menu-card.component.html',
    styleUrl: './menu-card.component.css'
})
export class MenuCardComponent {

  @Input() menuItem: MenuItem = {label: "", href: "", permission: ROLES.user};

  constructor(
    public router: Router,
  ) {
  }

}
